export interface RequestOptions extends RequestInit {
  headers?: {
    [key: string]: string;
  };
}

export const requestWithOptions = (endpoint: string, options: RequestOptions = {} as RequestOptions) => {
  const headers = new Headers();
  headers.set('Content-Type', 'application/json');

  const optionHeaders = options.headers || {};

  Object.keys(optionHeaders).forEach(key => {
    if (key && optionHeaders[key]) {
      headers.set(key, optionHeaders[key]);
    }
  });

  const req = new Request(endpoint, {
    ...options,
    headers
  });

  return fetch(req)
    .then(async resp => {
      if (resp.ok) {
        return resp;
      }
      return Promise.reject(await resp.json());
    })
    .catch((error: Response) => {
      console.error(`Failed while fetching from endpoint '${endpoint}'`, error);
      return Promise.reject(error);
    });
};

export const fetchDelete = (endpoint: string, options?: RequestOptions) => {
  return requestWithOptions(endpoint, {
    ...options,
    method: 'DELETE'
  });
};

export const fetchGet = (endpoint: string, options?: RequestOptions) => {
  return requestWithOptions(endpoint, {
    ...options,
    method: 'GET'
  });
};

export const fetchPost = (endpoint: string, options?: RequestOptions) => {
  return requestWithOptions(endpoint, {
    ...options,
    method: 'POST'
  });
};

export const fetchPut = (endpoint: string, options?: RequestOptions) => {
  return requestWithOptions(endpoint, {
    ...options,
    method: 'PUT'
  });
};

export const fetchPatch = (endpoint: string, options?: RequestOptions) => {
  return requestWithOptions(endpoint, {
    ...options,
    method: 'PATCH'
  });
};
